module.exports = __webpack_public_path__ + "img/title_discount.9e812425.png";